// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 873) return "7.0.31593-lazy-image.min.js";
	if (chunkId === 329) return "7.0.31593-datepicker.min.js";
	if (chunkId === 405) return "7.0.31593-context-info.min.js";
	if (chunkId === 171) return "7.0.31593-control-panel.min.js";
	if (chunkId === 927) return "7.0.31593-create-task.min.js";
	if (chunkId === 43) return "7.0.31593-create-task-modal.min.js";
	// return url for filenames based on template
	return undefined;
};